import { Component, Input } from '@angular/core';
import { RequestBuilderService } from '../../request-builder.service';
import { ActorActionEnum, Is_Adopt_Action, Is_ANY_Download_Action, Is_Approve_Action, Is_Download_Action, Is_File_Action, Is_NON_Download_Action, Is_OptionalDownload_Action, Is_Sign_Action, Is_Sign_OR_Approve_Action } from 'src/app/constants/actor-action.enum';
import { AllowedAction, WorkflowStep3 } from 'src/app/models/workflow';
import { DocumentTypeEnum } from 'src/app/constants/document-type.enum';
import { DocumentModel } from 'src/app/models/document.model';
import { DocumentActor } from 'src/app/models/actors';
import { SingleOrDefault } from 'src/app/_helpers/ArrayExtensionMethodHelper.functions';
import { Subscription } from 'rxjs';
import { actionValidationSummary } from 'src/app/models/requests';

@Component({
  selector: 'app-action-table-documents',
  templateUrl: './action-table-documents.component.html'
})
export class ActionTableDocumentsComponent {
  
  @Input() documents: any[] = [];
  @Input() allowDelete: boolean = true;
  public workflowDataStep3: WorkflowStep3 = <WorkflowStep3>{};
  public allowDownloadActions: boolean = false;
  private hasPlaceholders: boolean = false;
  private actionValidationRequest!: actionValidationSummary;
  actorActionEnum = ActorActionEnum;
  public possibleActionsOnDocument: ActorActionEnum[] = [];
  public blockedActionsOnDocument: ActorActionEnum[] = [];
  public actionsForDocument: Map<string, string[]> = new Map;
  

  private workflowSubscription: Subscription | null = null;
  private requestSubscription: Subscription | null = null;

  constructor(private requestBuilderService: RequestBuilderService) {
    this.workflowSubscription= this.requestBuilderService.workflowData$.subscribe(workflowData => {
      this.workflowDataStep3 = workflowData.step3;
      this.allowDownloadActions = this.workflowDataStep3.allowedActions?.filter(action => Is_ANY_Download_Action(action.type)).length > 0;
      this.hasPlaceholders = this.workflowDataStep3.placeholders?.length > 0;
    });
    this.requestSubscription = this.requestBuilderService.validationSummary$.subscribe(validationSummary => {
      this.actionValidationRequest = validationSummary.actionValidationSummary!;
    });
  }

  ngOnDestroy(): void {
    if(this.workflowSubscription){
      this.workflowSubscription.unsubscribe();
    }
    if(this.requestSubscription){
      this.requestSubscription.unsubscribe();
    }
  }

  allowedActionsForDocument(documentId: string) {
    this.possibleActionsOnDocument = this.actionValidationRequest?.documents?.find(s => s.documentGuid === documentId)?.possibleActions ?? [];
    this.blockedActionsOnDocument = this.actionValidationRequest?.documents?.find(s => s.documentGuid === documentId)?.blockedActions ?? [];
    this.actionsForDocument.set(documentId, this.possibleActionsOnDocument?.concat(this.blockedActionsOnDocument).filter((s:string) => s !== undefined && s.toLocaleLowerCase() !== "unspecified"));
    return this.actionsForDocument.get(documentId);
  }


  countActorsOfDocument(documentId: string) {
    return this.requestBuilderService.getCountActorsOfDocument(documentId);
  }

  displayActionsPerDocument(documentId: string | null = null) {
    let documentActors: DocumentActor[] = [];
    if(!documentId) {
      this.requestBuilderService.actors$.subscribe(actors => {
        if(actors && actors.length > 0) {
          documentActors = actors.filter(action => Is_ANY_Download_Action(action.action));
        }
      });
    } else {
      let document = SingleOrDefault<DocumentModel>(this.documents, "id", documentId);
      if(document){
        documentActors = document.actors.filter(actor => Is_NON_Download_Action(actor.action));
      }
    }
    return documentActors;
  }

  hasDocumentOneOrMoreActions(documentId: string) {
    return this.countActorsOfDocument(documentId) ? true : false;
  }

  // showActionButton(action: string, documentId: string|null = null) {
  //   if(this.hasPlaceholders){
  //     let doc = SingleOrDefault(this.documents, "id", documentId);
  //     let allowedActionsIndex = this.workflowDataStep3.placeholders.find(s => s.defaultDocumentPlaceholderId === doc.workflowPlaceholderId)!.allowedActions.findIndex((a: string) => a == action) ?? -1;
  //     // HIDE if the action is not in the allowedActions
  //     if (this.workflowDataStep3.placeholders.find(s => s.defaultDocumentPlaceholderId === doc.workflowPlaceholderId)!.allowedActions && allowedActionsIndex == -1) {
  //       return false;
  //     }
  //     // otherwise it is fine 
  //     return true;  
  //   }
  //   let allowedActionsIndex = this.workflowDataStep3.allowedActions?.findIndex((a: AllowedAction) => a.type == action) ?? -1;
  //   // HIDE if the action is not in the allowedActions
  //   if (this.workflowDataStep3.allowedActions && allowedActionsIndex == -1) {
  //     return false;
  //   }
  //   // otherwise it is fine 
  //   return true;
  // }

  disableOptionalDownload(): boolean {
    return false;
    // return (!this.requestBuilderService.mockActors || this.requestBuilderService.mockActors.length <= 0);
  }

  disableAction(action: string): boolean {
    return this.blockedActionsOnDocument.includes(<ActorActionEnum>action);
  }

  noMoreActionsPossible(): boolean {
    return this.disableAction(ActorActionEnum.Sign) && this.disableAction(ActorActionEnum.Approve) && this.disableAction(ActorActionEnum.Download);
  }

  isSignAction(action: ActorActionEnum): boolean {
    return Is_Sign_Action(action);
  }
  
  DisplaySigningFieldNotPlaced(person: DocumentActor, action: ActorActionEnum, document: DocumentModel): boolean {
    return this.isSignAction(action) && document?.documentType === DocumentTypeEnum.RegularPdf && ((person.sigFieldPage <= 0) || (!person.sigFieldW && !person.sigFieldH));
  }

  openActionDialog(documentGuid: string, desiredActionType: string) {
      this.requestBuilderService.openActionDialog(documentGuid, <ActorActionEnum>desiredActionType);

  }

  checkForDisableAddActions(documentId: string) {
    return !this.actionValidationRequest?.documents?.find(s => s.documentGuid === documentId)?.allowsMoreActions;
  }
}
